import { c as _c } from "react/compiler-runtime";
import React, { Fragment, PropsWithChildren } from 'react';
import { Label, Listbox, ListboxButton, ListboxOptions, Transition } from '@headlessui/react';
import classNames from 'classnames';
import Icon from '@/src/app/components/Icon/Icon';
import { IconName } from '@/src/app/components/Icon/types';
export interface DropdownProps extends PropsWithChildren {
  label?: string;
  placeholder?: string;
  disabled?: boolean;
  name: string;
  labelIcon?: IconName;
  isActive?: boolean;
}
function Dropdown(t0) {
  const $ = _c(10);
  const {
    placeholder: t1,
    label,
    name,
    disabled,
    labelIcon,
    children,
    isActive
  } = t0;
  const placeholder = t1 === undefined ? "Please select a value" : t1;
  let t2;
  if ($[0] !== children || $[1] !== isActive || $[2] !== label || $[3] !== labelIcon || $[4] !== name || $[5] !== placeholder) {
    t2 = t3 => {
      const {
        open
      } = t3;
      return <div>{label ? <Label className="label mb-1" htmlFor={name}>{label}</Label> : null}<div className={classNames("relative bg-white", "before:block before:w-[0.25rem] before:h-full before:absolute before:left-[1px] before:top-0 before:z-10", {
          "before:bg-black": isActive || open
        })}><ListboxButton className={classNames("input flex relative w-full cursor-default text-left pr-9 focus:border-black focus:outline-none focus:ring-1 focus:ring-black", {
            "bg-black border-black": open
          })}>{labelIcon ? <Icon name={labelIcon} className={classNames("mr-2", {
              "text-black": !isActive && !open,
              "text-white": open
            })} /> : null}<span className={classNames("block truncate", {
              "text-gray-400": !isActive && label && !open,
              "text-white": open
            })}>{placeholder ?? label}</span><span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2"><Icon name={open ? IconName.EXPAND_LESS : IconName.EXPAND_MORE} className={classNames({
                "text-black": !open,
                "text-white": open
              })} aria-hidden="true" /></span></ListboxButton><Transition show={open} as={Fragment} leave="transition ease-in duration-100" leaveFrom="opacity-100" leaveTo="opacity-0"><ListboxOptions className="absolute z-20 max-h-60 overflow-auto bg-white text-base border border-t-0 border-gray-300 focus:outline-none min-w-full">{children}</ListboxOptions></Transition></div></div>;
    };
    $[0] = children;
    $[1] = isActive;
    $[2] = label;
    $[3] = labelIcon;
    $[4] = name;
    $[5] = placeholder;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== disabled || $[8] !== t2) {
    t3 = <div data-testid="dropdown"><Listbox disabled={disabled}>{t2}</Listbox></div>;
    $[7] = disabled;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}
export default Dropdown;